var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "unified-navigation-ui": "static-1.26680",
      "ably-hubspot-js": "static-2.3366",
      "breadcrumbs-ui": "static-1.1866",
      "client-types": "static-1.373",
      "enviro": "static-4.306",
      "head-dlb": "static-1.4003",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.4318",
      "hs-test-utils": "static-1.6786",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3149",
      "HubStyleTokens": "static-2.10287",
      "I18n": "static-7.1391",
      "jasmine-runner": "static-1.5195",
      "nav-client-types": "static-1.1156",
      "nav-meta": "static-1.25473",
      "navigation-components": "static-1.13836",
      "navigation-components-tests": "static-1.10446",
      "navigation-messaging": "static-1.3163",
      "quartz": "static-1.5542",
      "react": "static-7.151",
      "react-dnd": "static-2.33",
      "react-dnd-html5-backend": "static-2.10",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "rpc-client-utils": "static-1.3504",
      "trials-service-types": "static-1.2880",
      "target-element-observer": "static-1.985",
      "webpack-env": "static-1.54",
      "wootric-nps": "static-1.5725",
      "ably": "static-2.2",
      "calling-internal-common": "static-1.30018",
      "classnames": "static-2.10",
      "crosstab": "static-1.3398",
      "ExtensionInstallHelpers": "static-1.536",
      "foundations-components": "static-1.5984",
      "foundations-theming": "static-1.3108",
      "foundations-theming-base": "static-1.2093",
      "foundations-theming-specialty": "static-1.825",
      "frontend-preferences-client": "static-1.6659",
      "global-search-externals": "static-1.11258",
      "idb-keyval": "static-1.20",
      "magpie-lib": "static-1.4462",
      "magpie-types": "static-1.3922",
      "metrics-js": "static-1.8561",
      "nav-onboarding-tours": "static-1.2265",
      "notification-sounds": "static-1.3223",
      "prefetcher": "static-1.4569",
      "react-dom": "static-7.85",
      "react-utils": "static-2.4311",
      "redux-thunk": "static-2.43",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.6964",
      "simple-logging-lib": "static-1.1824",
      "styled-components": "static-2.64",
      "superstore": "static-1.3560",
      "trial-components-library": "static-1.10893",
      "ts-schema": "static-1.3122",
      "ui-images": "static-2.832",
      "usage-tracker-core": "static-1.6105",
      "hs-promise-rejection-tracking": "static-1.4306",
      "PortalIdParser": "static-2.284",
      "raven": "static-3.4766",
      "raven-hubspot": "static-1.5073",
      "bend-plugin-trellis-migration": "static-1.2441",
      "moment": "static-3.26",
      "quartz-core": "static-1.4761",
      "HeadJS": "static-2.577",
      "framer-motion": "static-1.40",
      "hs-test-utils-bend-plugin": "static-1.1897",
      "msw": "static-1.39",
      "testing-library": "static-1.120",
      "i18n-data": "static-1.197",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.3129",
      "quartz-core-utils": "static-1.2409",
      "StyleGuideUI": "static-3.461",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "quick-fetch": "static-1.2772",
      "HubStyle": "static-2.10596",
      "calling-error-reporting": "static-1.30024",
      "calling-usage-tracker": "static-1.5281",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "self-service-api": "static-1.8996",
      "SharedI18nStrings": "static-1.162",
      "UIComponents": "static-3.7235",
      "bend-plugin-foundations-components": "static-1.2252",
      "floating-ui": "static-1.28",
      "foundations-assets": "static-1.3714",
      "hs-story-utils": "static-1.8184",
      "react-aria": "static-1.38",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.73",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.332",
      "bend-plugin-foundations-theming": "static-1.1591",
      "hub-http-janus": "static-1.648",
      "global-search-shared": "static-1.11973",
      "usage-tracker": "static-1.6255",
      "autolinker": "static-3.11",
      "sanitize": "static-1.3175",
      "transmute": "static-2.29",
      "ai-components-ui-library": "static-1.5219",
      "atom": "static-1.4002",
      "copilot-toolkit": "static-1.6326",
      "demographics-client": "static-1.4199",
      "hubs-service-types": "static-1.251",
      "icons": "static-2.592",
      "laboratory-lib": "static-3.6044",
      "onboarding-scopes": "static-1.5345",
      "react-input-autosize": "static-2.17",
      "salesImages": "static-1.500",
      "signup-constants": "static-1.16242",
      "ui-addon-i18n": "static-1.9713",
      "ui-addon-upgrades": "static-9.16023",
      "user-context": "static-1.3963",
      "dispatcher": "static-1.112",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-shared-msw-handlers": "static-1.7047",
      "hubspotter-http": "static-1.3573",
      "hubspotter-http-shared-msw-handlers": "static-1.7045",
      "mobile-manifest-mixins": "static-1.348",
      "platform-navigation-bootstrap": "static-1.11199",
      "react-rhumb": "static-1.15368",
      "react-router-dom": "static-5.26",
      "cssUtils": "static-1.493",
      "customer-data-ui-utilities": "static-1.8515",
      "ai-addon-copilot-preview": "static-1.4431",
      "apollo-link-hub-http": "static-2.3570",
      "apollo-stack-hubspot": "static-3.43",
      "data-fetching-client": "static-1.8406",
      "graphql": "static-1.58",
      "search-service-types": "static-1.2768",
      "chatspot-client-types": "static-1.8552",
      "chatspot-core": "static-1.15561",
      "ContentUtils": "static-1.63232",
      "sassPrefix": "static-1.131",
      "foundations-components-test-utils": "static-1.3469",
      "feature-store-service-types": "static-1.3472",
      "growth-monetization-service-types": "static-1.3479",
      "upgrade-management-service-types": "static-1.3463",
      "getting-started-shared-tasks": "static-1.12544",
      "getting-started-shared-tasks-store": "static-1.11662",
      "platform-infra-nav-components": "static-1.6681",
      "react-dnd-compat": "static-1.3444",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "ai-settings-ui-library": "static-1.5903",
      "apollo-dlb": "static-3.41",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.3576",
      "content-icons-ui": "static-1.1889",
      "underscore": "static-1.8",
      "ui-addon-avatars": "static-2.8156",
      "ui-addon-react-router-dom": "static-1.8397",
      "usage-tracker-container": "static-1.6245"
    },
    "depPathPrefixes": {
      "unified-navigation-ui": "/unified-navigation-ui/static-1.26680",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3366",
      "breadcrumbs-ui": "/breadcrumbs-ui/static-1.1866",
      "client-types": "/client-types/static-1.373",
      "enviro": "/enviro/static-4.306",
      "head-dlb": "/head-dlb/static-1.4003",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.4318",
      "hs-test-utils": "/hs-test-utils/static-1.6786",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3149",
      "HubStyleTokens": "/HubStyleTokens/static-2.10287",
      "I18n": "/I18n/static-7.1391",
      "jasmine-runner": "/jasmine-runner/static-1.5195",
      "nav-client-types": "/nav-client-types/static-1.1156",
      "nav-meta": "/nav-meta/static-1.25473",
      "navigation-components": "/navigation-components/static-1.13836",
      "navigation-components-tests": "/navigation-components-tests/static-1.10446",
      "navigation-messaging": "/navigation-messaging/static-1.3163",
      "quartz": "/quartz/static-1.5542",
      "react": "/react/static-7.151",
      "react-dnd": "/react-dnd/static-2.33",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "rpc-client-utils": "/rpc-client-utils/static-1.3504",
      "trials-service-types": "/trials-service-types/static-1.2880",
      "target-element-observer": "/target-element-observer/static-1.985",
      "webpack-env": "/webpack-env/static-1.54",
      "wootric-nps": "/wootric-nps/static-1.5725",
      "ably": "/ably/static-2.2",
      "calling-internal-common": "/calling-internal-common/static-1.30018",
      "classnames": "/classnames/static-2.10",
      "crosstab": "/crosstab/static-1.3398",
      "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.536",
      "foundations-components": "/foundations-components/static-1.5984",
      "foundations-theming": "/foundations-theming/static-1.3108",
      "foundations-theming-base": "/foundations-theming-base/static-1.2093",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.825",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.6659",
      "global-search-externals": "/global-search-externals/static-1.11258",
      "idb-keyval": "/idb-keyval/static-1.20",
      "magpie-lib": "/magpie-lib/static-1.4462",
      "magpie-types": "/magpie-types/static-1.3922",
      "metrics-js": "/metrics-js/static-1.8561",
      "nav-onboarding-tours": "/nav-onboarding-tours/static-1.2265",
      "notification-sounds": "/notification-sounds/static-1.3223",
      "prefetcher": "/prefetcher/static-1.4569",
      "react-dom": "/react-dom/static-7.85",
      "react-utils": "/react-utils/static-2.4311",
      "redux-thunk": "/redux-thunk/static-2.43",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.6964",
      "simple-logging-lib": "/simple-logging-lib/static-1.1824",
      "styled-components": "/styled-components/static-2.64",
      "superstore": "/superstore/static-1.3560",
      "trial-components-library": "/trial-components-library/static-1.10893",
      "ts-schema": "/ts-schema/static-1.3122",
      "ui-images": "/ui-images/static-2.832",
      "usage-tracker-core": "/usage-tracker-core/static-1.6105",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4306",
      "PortalIdParser": "/PortalIdParser/static-2.284",
      "raven": "/raven/static-3.4766",
      "raven-hubspot": "/raven-hubspot/static-1.5073",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2441",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4761",
      "HeadJS": "/HeadJS/static-2.577",
      "framer-motion": "/framer-motion/static-1.40",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1897",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.120",
      "i18n-data": "/i18n-data/static-1.197",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.3129",
      "quartz-core-utils": "/quartz-core-utils/static-1.2409",
      "StyleGuideUI": "/StyleGuideUI/static-3.461",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "HubStyle": "/HubStyle/static-2.10596",
      "calling-error-reporting": "/calling-error-reporting/static-1.30024",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5281",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "self-service-api": "/self-service-api/static-1.8996",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
      "UIComponents": "/UIComponents/static-3.7235",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2252",
      "floating-ui": "/floating-ui/static-1.28",
      "foundations-assets": "/foundations-assets/static-1.3714",
      "hs-story-utils": "/hs-story-utils/static-1.8184",
      "react-aria": "/react-aria/static-1.38",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.73",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.332",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1591",
      "hub-http-janus": "/hub-http-janus/static-1.648",
      "global-search-shared": "/global-search-shared/static-1.11973",
      "usage-tracker": "/usage-tracker/static-1.6255",
      "autolinker": "/autolinker/static-3.11",
      "sanitize": "/sanitize/static-1.3175",
      "transmute": "/transmute/static-2.29",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.5219",
      "atom": "/atom/static-1.4002",
      "copilot-toolkit": "/copilot-toolkit/static-1.6326",
      "demographics-client": "/demographics-client/static-1.4199",
      "hubs-service-types": "/hubs-service-types/static-1.251",
      "icons": "/icons/static-2.592",
      "laboratory-lib": "/laboratory-lib/static-3.6044",
      "onboarding-scopes": "/onboarding-scopes/static-1.5345",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "salesImages": "/salesImages/static-1.500",
      "signup-constants": "/signup-constants/static-1.16242",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.9713",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16023",
      "user-context": "/user-context/static-1.3963",
      "dispatcher": "/dispatcher/static-1.112",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7047",
      "hubspotter-http": "/hubspotter-http/static-1.3573",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7045",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.348",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11199",
      "react-rhumb": "/react-rhumb/static-1.15368",
      "react-router-dom": "/react-router-dom/static-5.26",
      "cssUtils": "/cssUtils/static-1.493",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8515",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4431",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3570",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "data-fetching-client": "/data-fetching-client/static-1.8406",
      "graphql": "/graphql/static-1.58",
      "search-service-types": "/search-service-types/static-1.2768",
      "chatspot-client-types": "/chatspot-client-types/static-1.8552",
      "chatspot-core": "/chatspot-core/static-1.15561",
      "ContentUtils": "/ContentUtils/static-1.63232",
      "sassPrefix": "/sassPrefix/static-1.131",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3469",
      "feature-store-service-types": "/feature-store-service-types/static-1.3472",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3479",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3463",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.12544",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.11662",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6681",
      "react-dnd-compat": "/react-dnd-compat/static-1.3444",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5903",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.3576",
      "content-icons-ui": "/content-icons-ui/static-1.1889",
      "underscore": "/underscore/static-1.8",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.8156",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8397",
      "usage-tracker-container": "/usage-tracker-container/static-1.6245"
    },
    "project": "unified-navigation-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};